import React, { useEffect, useState } from "react";
import { Button, Card, Form, notification, Skeleton, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useStoreUpdaterWithAPI } from "../../../../Hooks/UseStoreUpdaterWithApi";
import { ConverterConfigGrid, UserConfigGrid } from "../../../../Common/UIConstants";
import { useSelector } from "react-redux";
import ConverterPopup from "../../../CommonScreens/CreateConverter";
import { CONFIGURATION_CONVERTER, CONFIGURATION_USER } from "../../../../Common/Constants";
import UserPopup from "../../../CommonScreens/CreateUser";

const UserRegistration = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { loading, makeRequest } = useStoreUpdaterWithAPI();
    
    const [isAdd, setIsAdd] = useState(false);
   
    const mode = useSelector((state) => state.darkMode);
  
    const { isdarkMode } = mode;
  
    const [form] = Form.useForm();
  
    useEffect(() => {
    
    }, []);
  
    useEffect(() => {
      if (location.pathname === `${CONFIGURATION_USER}/user-add-popup`) {
        setIsAdd(true);
       
      }else {
        setIsAdd(false);
      
      }
    }, [location.pathname]);
  
   
  
    const handleNotification = (msg) => {
      notification.open({
        message: `${msg}`,
      });
    };
  
    const handleAddPopup = () => {
      navigate(`${CONFIGURATION_USER}/user-add-popup`);
    };
  
  
  
    const handleDeletePopup = (record) => {
      setSelectedDeleteData(record.groupID);
    };
  
    const handleDeleteSubmit = (groupID) => {
      try {
        makeRequest({
          type: APIConstants.DELETE,
          url: `${APIConstants.DELETE_FLOW_GROUP_DETAILS}?GroupID=${groupID}&IsDelete=true`,
        });
  
        const updatedFlowGroupList = flowGroupList.filter(
          (item) => item.groupID !== groupID
        );
        setFlowGroupList(updatedFlowGroupList);
  
        handleNotification("Successfully Deleted");
        form.resetFields();
      } catch (err) {
        console.log(err);
      }
    };
  
    return (
      <div>
        <Card className={`w-full h-auto dark ${isdarkMode ? 'darkmode border-0' : 'whitemode'} `}>
          <div className="flex justify-end">
            <Button onClick={handleAddPopup} className="blue-btn mb-2">
              Add User
            </Button>
          </div>
  
          <UserPopup
            isAdd={isAdd}
            setIsAdd={setIsAdd}
            title={"User Registration"}
           
           
          />
  
          <div className="overflow-auto">
            <Spin indicator={<Spin size="large" />} spinning={loading}>
              <UserConfigGrid
              
                handleDeletePopup={handleDeletePopup}
                handleDeleteSubmit={handleDeleteSubmit}
               
              />
            </Spin>
          </div>
        </Card>
      </div>
    );
};

export default UserRegistration;
